export default __webpack_public_path__ + "static/media/closet1-2048w.c0c8cf80.avif";